module.exports = "/images/vendor/flag-icon-css/flags/1x1/sn.svg?d2bec7efb0241ffa5077b53dae7e54a1";